var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "about-us" },
        [
          _c(
            "el-container",
            { staticClass: "d-flex-column" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("img", {
                      staticClass: "img-responsive ",
                      attrs: {
                        src: require("../../../public/img/team/our-team.jpg"),
                        alt: "team"
                      }
                    })
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("h1", [_vm._v("Our Team")]),
                    _c("p", [
                      _vm._v(
                        "Maren Solutions technologies is gifted with passel of youngsters with highly skilled capabilities of developing products and delivering on time. We have a team that includes people across our country knowing the ropes in their fields. We believe unity in diversity"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "d-flex-column p-tb100" },
        [
          _c(
            "el-carousel",
            { attrs: { interval: 5000, arrow: "always" } },
            [
              _c("el-carousel-item", [
                _c("div", { staticClass: "team-slide" }, [
                  _c("div", { staticClass: "cont" }, [
                    _c("h4", {}, [
                      _vm._v(
                        "Maren, a home of young passel folks from different streams"
                      )
                    ]),
                    _c("h6", [_vm._v("Business Analysts")]),
                    _c("p", [
                      _vm._v(
                        "We have well adversed analysts to perform process modelling to  analyse the requirements with ease and freezes them with unique business strategic approach as per product lifecycle."
                      )
                    ])
                  ]),
                  _c("img", {
                    staticClass: "img-responsive ",
                    attrs: {
                      src: require("../../../public/img/team/team.png"),
                      alt: "team"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "team-slide" }, [
                  _c("div", { staticClass: "cont" }, [
                    _c("h6", [_vm._v("UI Designers")]),
                    _c("p", [
                      _vm._v(
                        "We have our team of designers who are up to date with the latest design trend with user centric designs"
                      )
                    ])
                  ]),
                  _c("img", {
                    staticClass: "img-responsive",
                    attrs: {
                      src: require("../../../public/img/team/team.png"),
                      alt: "team"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "team-slide" }, [
                  _c("div", { staticClass: "cont" }, [
                    _c("h6", [_vm._v("Developers")]),
                    _c("p", [
                      _vm._v(
                        "We have ample of  well experienced front end and back end developers who uses cutting edge technologies to develop the products "
                      )
                    ])
                  ]),
                  _c("img", {
                    staticClass: "img-responsive",
                    attrs: {
                      src: require("../../../public/img/team/team.png"),
                      alt: "team"
                    }
                  })
                ])
              ]),
              _c("el-carousel-item", [
                _c("div", { staticClass: "team-slide" }, [
                  _c("div", { staticClass: "cont" }, [
                    _c("h6", [_vm._v("Quality Analysts")]),
                    _c("p", [
                      _vm._v(
                        "A dedicated  testing team who applies quality engineering principals to validate the applications and ensures to deliver bug-free product "
                      )
                    ])
                  ]),
                  _c("img", {
                    staticClass: "img-responsive",
                    attrs: {
                      src: require("../../../public/img/team/team.png"),
                      alt: "team"
                    }
                  })
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/OurTeam.vue?vue&type=template&id=12b385a2&
// module id = 567
// module chunks = 4